<template>
  <div class="teacher-page">
    <div class="columns teacher-details">
      <div class="column is-two-fifths">
        <div class="third-container">
          <h1>{{ teacher.name }}</h1>
          <p class="sub-heading">
            <current-tag
              v-for="current in getCurrent"
              :key="current.id"
              :current="current"
            >
            </current-tag>
          </p>
          <p class="sub-heading">מספר שיעורים: {{ videoCount }}</p>
          <div v-html="teacher.content"></div>
          <a href="#" class="teacher-link">קישור לאתר מורה חיצוני</a>
        </div>
      </div>
      <div class="column is-three-fifths teacher-big-img">
        <img :src="imgPath" :alt="teacher.name" />
      </div>
    </div>

    <h2 class="section-header">השיעורים של {{ firstName }}</h2>

    <videos :videos="teacherVideos"></videos>

    <div v-if="teacherGvs.length > 0">
      <h2 class="section-header">סדרות אימונים</h2>

      <group-videos :items="teacherGvs"></group-videos>
    </div>
  </div>
</template>

<script>
import CurrentTag from "@/components/CurrentTag.vue";
import GroupVideos from "@/components/series/GroupVideos.vue";
import Videos from "@/components/Videos.vue";

export default {
  name: `TeacherPage`,

  components: {
    CurrentTag,
    GroupVideos,
    Videos
  },

  // beforeRouteEnter(to, from, next) {
  //   window.scrollTo(0, 0);
  //   next((vm) => {
  //     vm.getTeacher(vm, to.params.tid);
  //   });
  // },

  // beforeRouteUpdate(to, from, next) {
  //   this.getTeacher(this, to.params.tid);
  //   window.scrollTo(0, 0);
  //   next();
  // },

  computed: {
    teacher() {
      let output = [];
      if (Array.isArray(this.$store.state.initialData.teachers)) {
        const arr = this.$store.state.initialData.teachers.filter(item => {
          if (item.id === this.$route.params.tid) {
            return true;
          }
          return false;
        });
        output = arr[0];
      }
      return output;
    },

    firstName() {
      if (this.teacher.name) {
        const nameArr = this.teacher.name.split(` `);
        return nameArr[0];
      }
      return ``;
    },

    videoList() {
      return this.$store.state.videos;
    },

    imgPath() {
      return this.$store.state.initialData.basepath + this.teacher.imgBig;
    },
    getCurrent() {
      const curList = [];
      if (Array.isArray(this.$store.state.initialData.currents)) {
        this.$store.state.initialData.currents.forEach(c => {
          if (Array.isArray(this.teacher.currents)) {
            this.teacher.currents.forEach(tc => {
              if (parseInt(tc.tag, 10) === parseInt(c.id, 10)) {
                curList.push(c);
              }
            });
          }
        });
      }

      return curList;
    },

    teacherVideos() {
      let videos = [];
      if (Array.isArray(this.$store.state.videos)) {
        videos = this.$store.state.videos.filter(video => {
          if (video.videoTeacher === this.teacher.id) {
            return true;
          }
          return false;
        });
      }
      return videos;
    },

    videoCount() {
      return this.teacherVideos.length;
    },

    teacherGvs() {
      const list = {};

      this.$store.state.series.forEach(s => {
        if (s.videoItems !== ``) {
          s.videoList.forEach(v => {
            if (v.videoTeacher === this.teacher.id && s.parent === `10`) {
              list[s.id] = s;
            }
          });
        }
      });

      return Object.values(list);
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  }

  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
$black: #191919;
$white: #ffffff;

.teacher-page {
  margin: 0 auto;
}

.teacher-details {
  font-weight: 300;
  background-color: $white;
  .is-two-fifths,
  .is-three-fifths {
    padding-bottom: 0;
  }
  h1 {
    font-weight: bold;
    margin-top: 50px;
  }
  p {
    margin-top: 30px;
    text-align: justify;
    max-width: 450px;
  }
  .sub-heading {
    margin: 0;
  }
  a.teacher-link {
    color: $black;
    text-decoration: underline;
    font-weight: 500;
  }
}

.third-container {
  padding-right: 15px;
}

.teacher-big-img {
  text-align: left;
  img {
    vertical-align: bottom;
  }
}

@media screen and (min-width: 1680px) {
  .third-container {
    padding-right: 23%;
  }
}
</style>
